<template>
  <div>
    <loader v-if="isLoading" />
    <main-header :login="true" />
    <div class="main-block custom">
      <div class="top__block analytics">
        <h1>
          <analytics-title
            :type="$route.params.type"
            :title="''"
          />
          &nbsp;ID: {{ $route.params.id }}
        </h1>
        <div class="top__info--block">
          <div class="breadcrumbs__block">
            <router-link
              :to="{
                path: `/analytics/${$route.params.type}`,
              }"
              class="breadcrumbs__first"
            >
              {{ $t('overall_statistics') }} /
            </router-link>
            <router-link
              :to="{
                path: `/analytics/step/${$route.params.type}/${idStep1}`,
              }"
              class="breadcrumbs__first"
            >
              {{ name }} /
            </router-link>
            <p class="breadcrumbs__this">
              {{ geoName }}
            </p>
          </div>
        </div>
      </div>
      <div class="first-tab">
        <div class="wrapper">
          <div
            id="sort-bar"
            style="margin-top: 0"
            class="sort-bar anal"
          >
            <filters-multiselect
              :placeholder="$t('geo')"
              :multiple="true"
              :model="searchGeoValue"
              :options="geoList"
              @searchItem="geoPage"
            />
            <button
              :class="{ active: isLoadingFile }"
              class="download__csv"
              @click="downloadFile"
            >
              <loader v-if="isLoadingFile" />
              <span v-if="!isLoadingFile">{{ $t('download_xlsx') }}</span>
            </button>
          </div>
          <div class="table__info">
            <simple-multiselect
              :label="$t('show_entries')"
              :class-name="'count__list'"
              :placeholder="'25'"
              :multiple="false"
              :model="valueEntries"
              :options="listOptions"
              @searchItem="limitPage"
            />
          </div>
          <table-custom
            :head-items="headItems"
            :body-items="analyticsItems"
            :total-items="totals"
            :step="3"
            :date-from="$route.params.dateTo.split('-')[2]"
            :date-to="$route.params.dateFrom.split('-')[2]"
            @goToApps="goToApps"
          />
        </div>
        <ul
          v-if="showPag"
          class="pagination"
        >
          <li
            v-for="pag in pagination.pages"
            :key="pag"
            :class="{ active: paginationPage_default == pag }"
            @click="paginationPage(pag)"
          >
            {{ pag }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import MainHeader from "@/components/header/header.vue";
import AnalyticsTitle from "@/components/elements/analyticsTitle.vue";
import tableCustom from "@/components/analytics/tableAnalytics.vue";
import simpleMultiselect from "@/components/elements/simpleMultiselect.vue";
import filtersMultiselect from "@/components/elements/filtersMultiselect.vue";
import loader from "@/components/elements/loader.vue";
import { HTTP } from "@/../axios-config";

export default {
  name: "AnalyticsGeo",
  components: {
    AnalyticsTitle,
    MainHeader,
    tableCustom,
    simpleMultiselect,
    filtersMultiselect,
    loader,
  },
  props: ["typePush", "pushId"],
  data() {
    return {
      isLoadingFile: false,
      isLoading: false,
      datesFrom: this.dateFrom,
      showPag: false,
      listOption_default: 25,
      paginationPage_default: 1,
      viewGeoPage_default: "all",
      valueEntries: "",
      geoList: [],
      searchGeoValue: "",
      headItems: [
        { name: "#" },
        // { name: "Время" },
        // { name: "Название" },
        // { name: "Заголовок" },
        // { name: "Текст" },
        {name: this.$t('geos'),},
        {name: this.$t('send'),},
        {name: this.$t('deliver'),},
        {name: this.$t('not_send'),},
        {name: this.$t('click'),},
        { name: "CTR", },
        {name: this.$t('regs')},
        {name: "Click2Reg"},
        {name: "FD"},
        {name: "Click2Dep"},
        {name: "Dep sum."},
        {name: "Repeat Dep sum."},
        { name: "" },
      ],
      listOptions: ["25", "50", "100"],
      analyticsItems: [],
      pagination: [],
      name: '',
      geoName: '',
      idStep1: '',
      totals: null,
    };
  },
  mounted() {
    this.getAnalytics();
    this.name = localStorage['companyName'];
    this.geoName = localStorage['geoName'];
    this.idStep1 = localStorage['id'];
  },
  methods: {
    goToApps(pushGeo) {
      this.$router.push(
        `/analytics/${this.$route.params.type}/${this.$route.params.dateTo}/${this.$route.params.dateFrom}/${this.$route.params.idPush}/${pushGeo}`
      );
    },
    paginationPage(page) {
      this.paginationPage_default = page;
      this.getAnalytics();
    },
    limitPage(limit) {
      this.listOption_default = limit;
      this.paginationPage_default = 1;
      this.getAnalytics();
    },
    geoPage(geoId) {
      if (geoId.length < 1) {
        this.viewGeoPage_default = "all";
      } else {
        this.viewGeoPage_default = geoId[0].code;
        for (let i = 1; i < geoId.length; i++) {
          this.viewGeoPage_default += `,${geoId[i].code}`;
        }
      }
      this.getAnalytics();
    },
    getAnalytics() {
      // history.pushState(null, null, location.href);
      window.onpopstate = function () {
        history.history.pushState(null, null, `/analytics/${$route.params.type}`);
      };
      const vm = this;
      this.analyticsItems = [];
      this.pagination = [];
      this.isLoading = true;
      HTTP.get(
        `/analytics/push/step3/${vm.$route.params.idPush}?geo=${this.viewGeoPage_default}&limit=${this.listOption_default}&page=${this.paginationPage_default}&dateFrom=${this.$route.params.dateTo}&dateTo=${this.$route.params.dateFrom}`
      )
        .then((response) => {
          let data = response.data;
          let filterItems = data.filter;

          if (this.geoList.length === 0) {
            this.geoList = filterItems.geo;
          }
          this.analyticsItems = data.content;
          this.pagination = data.pagination;
          this.totals = data.totals;

          this.showPag = this.pagination.pages > 1 ? true : false;
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);

            if (error.response.status === 401) {
              localStorage.removeItem("token");
              vm.$router.push({ name: "Login" });
            }

        });
    },
    downloadFile() {
      const vm = this;
      this.isLoadingFile = true;
      HTTP.get(
        `/front/analytics/download/step2/${vm.$route.params.id}?geo=${this.viewGeoPage_default}&dateFrom=${this.$route.params.dateTo}&dateTo=${this.$route.params.dateFrom}`
      )
        .then((response) => {
          let data = response.data.data;
          let link = data.url;

          let linkDownload = document.createElement("a");
          linkDownload.setAttribute("href", link);
          linkDownload.setAttribute("download", "download");
          onload = linkDownload.click();

          console.log("data", link);
          this.isLoadingFile = false;
        })
        .catch(function (error) {
          console.log(error);

            if (error.response.status === 401) {
              localStorage.removeItem("token");
              vm.$router.push({ name: "Login" });
            }

        });
    },
  },
};
</script>
